import React from 'react';
import PropTypes from 'prop-types';

export const NONE_OPTION_LABEL = 'None';

const AgentOptions = ({ agents }) => (
  <React.Fragment>
    <option value="">{NONE_OPTION_LABEL}</option>
    {agents.map((agent) => (
      <option key={agent.id} value={agent.id}>
        {agent.name}
      </option>
    ))}
  </React.Fragment>
);

AgentOptions.propTypes = {
  agents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
};

export default AgentOptions;
